import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export const serviceComputed = {
	...mapState('bomInfoStore', Object.keys(state)),
	...mapGetters('bomInfoStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('bomInfoStore', Object.keys(actions)),
	...mapMutations('bomInfoStore', Object.keys(mutations))
};
